import { ElleStandaloneFrontCoverstoryProps } from '@/elle/components/FrontCoverstory';
import { StandaloneComponent } from '@/types/component';

// Elle specific component

export const StandaloneFrontCoverstory: StandaloneComponent<ElleStandaloneFrontCoverstoryProps> = () => null;
